import { useState } from "react";
import { useIntl } from "react-intl";
import OverlayTrigger from "@rio-cloud/rio-uikit/OverlayTrigger";
import Tooltip from "@rio-cloud/rio-uikit/Tooltip";

import CheckupDetailDialog from "../dialogs/checkupDetailDialog";
import { Scheduling } from "../../../../../models/schedule";

interface ICheckupInfoProps {
    scheduling?: Scheduling;
}

const CheckupInfo = ({ scheduling }: ICheckupInfoProps) => {
    const intl = useIntl();
    const [checkupDetailDialog, setCheckupDetailDialog] = useState<boolean>(false);

    // Função para formatar a informação do odômetro
    const formatOdometerInfo = (odometer?: number) => {
        if (!odometer) return null;
        return `${odometer.toLocaleString('pt-BR')} km`;
    };

    // Função para obter informações de data e odômetro
    const getDateAndOdometerInfo = () => {
        const dateInfo = scheduling?.date?.toLocaleDateString('pt-BR');
        const odometerInfo = formatOdometerInfo(scheduling?.odometer);
        
        const infoArray = [dateInfo, odometerInfo].filter(Boolean);
        return infoArray.length > 0 ? infoArray.join(` ${intl.formatMessage({ id: "intl-msg:nextScheduling.or" })} `) : null;
    };

    return (
        scheduling ?
            <div>
                <OverlayTrigger
                    key={crypto.randomUUID()}
                    trigger="click"
                    placement="left"
                    overlay={
                        <Tooltip id="tooltip" allowOnTouch>
                            <div className="tooltip-card flex flex-column padding-10 gap-6">
                                <h3 className="flex flex-column text-size-18 font-bold items-start text-left">
                                    {scheduling?.checkup?.name}
                                    {getDateAndOdometerInfo() && (
                                        <span className="text-size-12 font-normal">
                                            {getDateAndOdometerInfo()}
                                        </span>
                                    )}
                                </h3>
                                <ul className="text-left">
                                    {
                                        scheduling?.checkup?.services
                                            .slice(0, 4)
                                            .map((service, index) => (
                                                <li key={index}>{service.name}</li>
                                            ))
                                    }
                                </ul>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => setCheckupDetailDialog(true)}
                                >
                                    <span>{intl.formatMessage({ id: "intl-msg:nextScheduling.viewCompleteList" })}</span>
                                </button>
                            </div>
                        </Tooltip>
                    }
                >
                    <span className="cursor-pointer rioglyph rioglyph-exclamation text-size-12 text-color-white icon-revision"></span>
                </OverlayTrigger>

                <CheckupDetailDialog
                    scheduling={scheduling}
                    showCheckupDetailDialog={checkupDetailDialog} 
                    setShowCheckupDetailDialog={(e:boolean) => setCheckupDetailDialog(e)} 
                />
            </div>
            : null
    );
}

export default CheckupInfo;